<template>
<div>
    <loading :show-loading="showLoading" />
    <div class="pc">
        <div class="con-icon"><img src="@/assets/newImages/common/common-icon.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-head">
                <p>生态伙伴</p>
            </div>
            <!-- 内容 -->
            <div class="con-main" :style="{height:pageHeight}">
                <div class="main">
                    <div class="partner">
                        <div class="parnter-title" @click="chooseSponsorTabOne()" v-if="sponsorSpecial.title">
                            <div class="title">
                                <div class="title-icon"><img src="@/assets/newImages/parnter/title-icon.png" alt=""></div>
                                <p>{{sponsorSpecial.title}}</p>
                            </div>
                            <div class="more" :class="{'more-active':sponsorSpecial.show==true}"><img src="@/assets/newImages/parnter/title-icon2.png" alt=""></div>
                        </div>
                        <div class="partner-sponsor partner-sponsor-one" v-show="sponsorSpecial.show">
                            <div class="sponsor-img" :class="{'sponsor-logo-active':sponsorSpecial.activeIcon==1}" @click="showInfoOne(sponsorSpecial.name, sponsorSpecial.title)">
                                <img :src="sponsorSpecial.image" alt="">
                                <div class="bg"><img src="@/assets/newImages/parnter/msg-border.png" alt=""></div>
                                <div class="partner-active">
                                    <p>{{sponsorSpecial.summary}}</p>
                                    <a style="display:none;" @click="jump(sponsorSpecial.url, sponsorSpecial.name, sponsorSpecial.sponsor_type)">访问官网   >></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="partner" v-for="(sponsor,index) in sponsorList" :key="index" :class="{'parnter-title':sponsorShow == index}">
                        <div class="parnter-title" @click="chooseSponsorTab(index)">
                            <div class="title">
                                <div class="title-icon"><img src="@/assets/newImages/parnter/title-icon.png" alt=""></div>
                                <p>{{sponsor.title}}</p>
                            </div>
                            <div class="more" :class="{'more-active':sponsor.show==true}"><img src="@/assets/newImages/parnter/title-icon2.png" alt=""></div>
                        </div>
                        <div class="partner-sponsor" v-show="sponsor.show">
                            <div class="sponsor-img" v-for="(icon,key) in sponsor.icon" :key="key" :style="{marginBottom:icon.marginBottom}" :class="{'sponsor-logo-active':sponsor.activeIcon==key}" @click="showInfo(sponsor.icon,key, icon.title, sponsor.title)">
                                <img :src="icon.coverImageRealPath" alt="">
                                <div class="bg"><img src="@/assets/newImages/parnter/msg-border.png" alt=""></div>
                                <div class="partner-active" :id="forId(index,key)">
                                    <p>{{icon.summary}}</p>
                                    <a style="display:none;" @click="jump(icon.url, icon.title, icon.sponsor_type)">访问官网   >></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tishi">*以上排名不分先后</div>
                </div>
            </div>
        </div>
    </div>
    <div class="wap">
        <div class="page-img"><img src="@/assets/newImages/common/navWap/page-img.png" alt=""></div>
        <div class="panter-main">
            <!-- 标题 -->
            <div class="panter-header"> <p>生态伙伴</p></div>
            <!-- 内容 -->
            <div class="main">
                <div class="partner">
                    <div class="parnter-title" @click="chooseSponsorTabOne()">
                        <div class="title">
                            <div class="title-icon"><img src="@/assets/newImages/parnter/title-icon.png" alt=""></div>
                            <p>{{sponsorSpecial.title}}</p>
                        </div>
                        <div class="more" :class="{'more-active':sponsorSpecial.show==true}"><img src="@/assets/newImages/common/navWap/title-icon.png" alt=""></div>
                    </div>
                    <div class="partner-sponsor" v-show="sponsorSpecial.show">
                        <div class="sponsor-img sponsor-img-one" :class="{'sponsor-logo-active':sponsorSpecial.activeIcon==1}" @click="showInfoOne(sponsorSpecial.name, sponsorSpecial.title)">
                            <img :src="sponsorSpecial.image" alt="">
                            <div class="bg"><img src="@/assets/newImages/parnter/msg-border.png" alt=""></div>
                            <div class="partner-active">
                                <p>{{sponsorSpecial.summary}}</p>
                                <a style="display:none;" @click="jump(sponsorSpecial.url, sponsorSpecial.name, sponsorSpecial.sponsor_type)">访问官网   >></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="partner" v-for="(sponsor,index) in sponsorList" :key="index">
                    <div class="parnter-title" @click="chooseSponsorTab(index)">
                        <div class="title">
                            <div class="title-icon"><img src="@/assets/newImages/parnter/title-icon.png" alt=""></div>
                            <p>{{sponsor.title}}</p>
                        </div>
                        <div class="more" :class="{'more-active':sponsor.show==true}"><img src="@/assets/newImages/common/navWap/title-icon.png" alt=""></div>
                    </div>
                    <div class="partner-sponsor" v-show="sponsor.show">
                        <div class="sponsor-img" v-for="(icon,key) in sponsor.icon" :key="key" :class="{'sponsor-logo-active':sponsor.activeIcon==key}" @click="showInfo(sponsor.icon,key, icon.title, sponsor.title)">
                            <img :src="icon.coverImageRealPath" alt="">
                            <div class="bg"><img src="@/assets/newImages/parnter/msg-border.png" alt=""></div>
                            <div class="partner-active" :id="forId(index,key)">
                                <p>{{icon.summary}}</p>
                                <a style="display:none;" @click="jump(icon.url, icon.title, icon.sponsor_type)">访问官网   >></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tishi">*以上排名不分先后</div>
            </div>
        </div>
    </div>
</div>
    
</template>
<script>
import api from '../api';
import loading from 'components/loading';
export default {
    components: {
        loading
    },
    data(){
        return{
            pageHeight:'',
            height:document.documentElement.clientHeight,
            width:document.documentElement.clientWidth,
            sponsorShow: 0,
            sponsorList:[],
            sponsorSpecial: {title: '', name: '', image: '', url: '', summary: '', show: false, activeIcon: -1},
            showLoading: true,
        }
    },
    created(){
        this.pageHeight = this.height-184/1920*this.width-63/1920*this.width+"px"
        this.getPartnerList();
    },
    mounted(){
        let self = this;
        this.$nextTick(() => {
            self.showLoading = false;
        })
    },
    methods:{
        // 生态伙伴
        getPartnerList(){
            let that = this;
            api.getPartnerList()
            .then(res=>{
                if(res){
                    let temp = [];
                    let data = res.slice(1, res.length);
                    let firstData = res.slice(0, 1)[0];
                    data.map((item, index)=>{
                        item.list.map(childItem=>{
                            childItem.marginBottom = '';
                        })
                        temp.push({
                            title: item.name,
                            show: true,
                            activeIcon:-1,
                            icon: item.list
                        });
                    });
                    that.sponsorList = temp;
                    that.sponsorSpecial = {
                        title: firstData.name,
                        name: firstData.list[0].title,
                        image: firstData.list[0].coverImageRealPath,
                        url: firstData.list[0].url,
                        summary: firstData.list[0].summary,
                        sponsor_type: firstData.list[0].sponsor_type,
                        show: true,
                        activeIcon: -1,
                    };
                }
            })
            .catch(err=>{
                that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
            });
        },
        jump(url, title='', type=''){

            // 埋码
            this.$maima.partner_page_company_click(title, type);

            return;
            window.open(url);
            return;
        },
        forId:function(index1,index2){
            return "active" +index1+"_"+index2
        },
        showInfo(data,index, name, type){
            this.sponsorList.forEach((item,num)=>{
                if(item.icon ==data){
                    item.icon.forEach((itemOne,num2)=>{
                        itemOne.marginBottom = ''
                    })
                    this.sponsorList[num].activeIcon = index
                    var height1=$("#active"+num+"_"+index).height()+30/1920*this.width+60/1920*this.width+"px"
                    this.sponsorList[num].icon[index].marginBottom =height1
                }
            })

            // 埋码
            this.$maima.partner_page_company_click(name, type);
        },
        showInfoOne(name, type){
            this.sponsorSpecial.activeIcon = 1

            // 埋码
            this.$maima.partner_page_company_click(name, type);
        },
        chooseSponsorTabOne(){
            this.sponsorSpecial.show = !this.sponsorSpecial.show
            this.sponsorSpecial.activeIcon = -1
        },
        chooseSponsorTab(index){
            this.sponsorList.forEach((item,num)=>{
                if(num == index){
                    this.sponsorList[num].show = !item.show
                    this.sponsorList[num].activeIcon = -1
                    item.icon.forEach((list,index)=>{
                        this.sponsorList[num].icon[index].marginBottom =''
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.pc{
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url('../assets/newImages/common/common-bg.png')no-repeat center center/cover;
    .con-icon{
        position: absolute;
        right: 0;
        bottom: 0;
        width: pxToVw(480);
        height: pxToVw(403);
        img{
            width: pxToVw(480);
            height: pxToVw(403);
        }
    }
    .content{
        width: pxToVw(1601);
        margin: pxToVw(0) pxToVw(0) 0 pxToVw(233);
        padding-top: pxToVw(49);
        position: relative;
        z-index: 2;
        .con-head{
            width: 100%;
            height: pxToVw(115);
            text-align: left;
            display: flex;
            justify-content: space-between;
            p{  
                width: pxToVw(351);//315
                height: pxToVw(115);//103
                padding: pxToVw(36) 0 0 pxToVw(92);
                font-size: pxToVw(43);
                font-family: "FZLT-blackBold";
                color: #FFF;
                line-height: pxToVw(52);
                background: url("../assets/newImages/common/common-title-bg.png")no-repeat center center/cover;
            }
        }
        .con-main{
            // width: 1520px;
            // height: pxToVw(774);
            margin: pxToVw(20) pxToVw(0) pxToVw(0) pxToVw(63);
            padding-right: pxToVw(18);
            overflow-y: scroll;
            scrollbar-width: none;
            -ms-overflow-style: none;
             /*滚动条样式*/
            &::-webkit-scrollbar{
                width: 3px;
                height: 100%;
                background: none;
            }
            &::-webkit-scrollbar-track{
                background: none;
            }
            &::-webkit-scrollbar-thumb{
                background: #DDDDDD;
            }
            .main{
                height: auto;
                // min-height: 100%;
                background: #FFFFFF;
                box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                border-radius: pxToVw(3);
                padding: pxToVw(0) pxToVw(69) pxToVw(39) pxToVw(60);
                .partner{
                    width: pxToVw(1394);
                    flex-direction: column;
                    .parnter-title{
                        display: flex;
                        justify-content: space-between;
                        border-bottom: 1px solid #EEEEEE;
                        height: pxToVw(89);
                        width: 100%;
                        cursor: pointer;
                        .title{
                            display: flex;
                            padding-top:pxToVw(39);
                            .title-icon{
                                width: pxToVw(55);
                                height: pxToVw(33);
                                img{
                                    width: pxToVw(55);
                                    height: pxToVw(33);
                                }
                            }
                            p{
                                font-size: pxToVw(21);
                                font-weight: normal;
                                color: #333333;
                                line-height: pxToVw(25);
                                font-family: "FZLT-blackLittle";
                                margin-left: pxToVw(3);
                            }
                        }
                        .more{
                            margin-top: pxToVw(35);
                            width: pxToVw(33);
                            padding: pxToVw(10) 0 pxToVw(10) pxToVw(10);
                            cursor: pointer;
                            height: pxToVw(31);
                            img{
                                vertical-align: top;
                                width: pxToVw(23);
                                height: pxToVw(11);
                                transform: rotate(180deg);
                                transition: all ease-in-out 0.3s;
                            }
                        }
                        .more-active{
                            img{
                                transform: rotate(0);
                            }
                        }
                    }
                    .partner-sponsor{
                        padding: pxToVw(35) pxToVw(0) pxToVw(0) pxToVw(40);
                        display: flex;
                        flex-wrap: wrap;
                        .sponsor-img{
                            position: relative;
                            width: pxToVw(160);
                            height: pxToVw(80);
                            margin: pxToVw(0) pxToVw(69) pxToVw(17) pxToVw(0);
                            cursor: pointer;
                            &:nth-child(6n+2){
                                .partner-active{
                                    left: pxToVw(-245);
                                }
                            }
                            &:nth-child(6n+3){
                                .partner-active{
                                    left: pxToVw(-474);
                                }
                            }
                            &:nth-child(6n+4){
                                .partner-active{
                                    left: pxToVw(-703);
                                }
                            }
                            &:nth-child(6n+5){
                                .partner-active{
                                    left: pxToVw(-932);
                                }
                            }
                            &:nth-child(6n){
                                margin-right: 0;
                                .partner-active{
                                    left: pxToVw(-1161);
                                }
                            }
                            img{
                                width: pxToVw(160);
                                height: pxToVw(80);
                            }
                            .bg{
                                display: none;
                                position: absolute;
                                top: pxToVw(0);
                                left: pxToVw(-1);
                                z-index: 2;
                                // background: yellowgreen;
                                width: pxToVw(163);
                                height: pxToVw(89);
                                img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .partner-active{
                                position: absolute;
                                top: pxToVw(107);
                                left: pxToVw(-16);
                                width: pxToVw(1337);
                                background: #FAFAFA;
                                padding: pxToVw(15) pxToVw(33);
                                display: none;
                                p{
                                    font-size: pxToVw(16);
                                    color: #666666;
                                    line-height: pxToVw(27);
                                }
                                a{
                                    font-size: pxToVw(16);
                                    line-height: pxToVw(27);
                                    color: #C50819;
                                    margin-top: pxToVw(25);
                                    text-decoration: underline;
                                }
                            }
                        }
                        .sponsor-logo-active{
                            .bg{
                                display: block;
                            }
                            .partner-active{
                                display: block;
                            }
                        }
                    }
                    .partner-sponsor-one{
                        padding: pxToVw(35) pxToVw(0) pxToVw(0) 0;
                        .sponsor-img{
                            margin: 0 auto;
                            .partner-active{
                                position: relative;
                                top: 0;
                                left: 0;
                                margin: pxToVw(17) 0 0 pxToVw(-588);
                            }
                        }
                        .sponsor-logo-active{
                            height: auto;
                            .bg{
                                display: block;
                            }
                            .partner-active{
                                display: block;
                            }
                        }
                    }
                }
            }
        }
        .tishi{
            font-size: pxToVw(14);
            width: 100%;
            text-align: right;
            color: #666666;
            line-height: pxToVw(18);
            margin-top: pxToVw(15);
        }
    }
}
.wap{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .wap{
        display: block;
        position: relative;
        z-index: 2;
        width: 100%;
        height: auto;
        min-height: 100vh;
        padding: 10vw 0 13.3vw;
        background: url('../assets/newImages/common/navWap/page-bg.png')no-repeat center center/cover;
        .page-img{
            position: absolute;
            bottom: 0;
            z-index: -1;
            right: 0;
            width: 38.1vw;
            height: 25.1vw;
            img{
                width: 38.1vw;
                height: 25.1vw;
            }
        }
        .panter-main{
            width: 100%;
            border-top: 1px solid #DDDDDD;
            .panter-header{
                height: 12.3vw;
                margin: 3.2vw 0 2.3vw;
                width: 100%;
                text-align: left;
                p{  
                    width: 37.6vw;
                    height: 12.3vw;
                    margin-left: -2.8vw;
                    padding: 4.1vw 0 0 10vw;
                    font-size: 4.3vw;
                    font-family: "FZLT-blackBold";
                    color: #FFF;
                    line-height: 5.2vw;
                    background: url("../assets/newImages/common/navWap/page-title.png") no-repeat center center/cover;
                }
            }
            .main{
                width: 100%;
                height: auto;
                .partner{
                    width: 90.9vw;
                    margin: 0 auto 3.5vw;
                    height: auto;
                    padding: 2.8vw 3.6vw 2vw;
                    background: rgba(255, 255, 255, 0.9);
                    box-shadow: 0 0 2.7vw 0 rgba(231,231,231,0.5);
                    border-radius: 0.3vw;
                    .parnter-title{
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        .title{
                            display: flex;
                            .title-icon{
                                width: 7.2vw;
                                height: 4vw;
                                margin: 0.7vw 0.5vw 0 0;
                                img{
                                    vertical-align: top;
                                    width: 7.2vw;
                                    height: 4vw;
                                }
                            }
                            p{
                                font-size: 3.5vw;
                                font-family: "FZLT-blackLittle";
                                color: #333333;
                                line-height: 4vw;
                            }
                        }
                        .more{
                            width: 6.7vw;
                            height: 4.6vw;
                            padding: 1.3vw 1.6vw;
                            img{
                                vertical-align: top;
                                width: 3.5vw;
                                height: 2vw;
                                transform: rotate(0);
                            }
                        }
                        .more-active{
                            img{
                                transform: rotate(180deg);
                            }
                        }
                    }
                    .partner-sponsor{
                        width: 100%;
                        height: auto;
                        display: flex;
                        flex-wrap: wrap;
                        margin-top: 2vw;
                        padding-top: 2.4vw;
                        border-top: 1px solid #EEEEEE;
                        .sponsor-img{
                            position: relative;
                            width: 26.7vw;
                            height: 13.3vw;
                            margin: 0 1.8vw 1.9vw 0;
                            cursor: pointer;
                            &:nth-child(3n+2){
                                .partner-active{
                                    margin-left: -25.7vw;
                                }
                            }
                            &:nth-child(3n){
                                margin-right: 0;
                                .partner-active{
                                    margin-left: -54.3vw;
                                }
                            }
                            img{
                                width: 26.7vw;
                                height: 13.3vw;
                            }
                            .bg{
                                display: none;
                                position: absolute;
                                top: 0;
                                left: 0;
                                z-index: 2;
                                width: 26.7vw;
                                height: 14.5vw;
                                img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .partner-active{
                                width: 78.8vw;
                                height: auto;
                                margin: 0.7vw 0 0 2.8vw;
                                background: #FAFAFA;
                                padding: 2.5vw 3.5vw;
                                display: none;
                                p{
                                    font-size: 3.2vw;
                                    color: #666666;
                                    line-height: 4.8vw;
                                }
                                a{
                                    font-size: 3.2vw;
                                    line-height: 4.8vw;
                                    color: #C50819;
                                    margin-top: 2vw;
                                    text-decoration: underline;
                                }
                            }
                        }
                        .sponsor-img-one{
                            margin: 0 auto;
                            .partner-active{
                                margin-left: -25.7vw;
                            }
                        }
                        .sponsor-logo-active{
                            height: auto;
                            .bg{
                                display: block;
                            }
                            .partner-active{
                                display: block;
                            }
                        }
                    }
                }
            }
        }
        .tishi{
            font-size: 3.2vw;
            width: 90.6vw;
            text-align: right;
            color: #666666;
            margin: 2vw auto 0;
            line-height: 4.8vw;
        }
    }
}
</style>